import { API_VERSIONS } from "../utils/constants";
import RequestHandler from "./RequestHandler";

function CouponsAPI() {
    const baseCouponsAPI = "coupons";

    async function getCoupons(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${API_VERSIONS.v1}/${baseCouponsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function addCoupon(payload) {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${baseCouponsAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        addCoupon,
        getCoupons,
    };
}

export default CouponsAPI();
